function eventKey(event) {
    return [
        event?.turn_id ?? "",
        event?.stage ?? "",
        event?.ts ?? "",
        event?.execution_id ?? "",
    ].join("|");
}

export function traceEventsFromTimeline(timeline = []) {
    const out = [];
    for (const item of Array.isArray(timeline) ? timeline : []) {
        if (item?.kind !== "trace_step") continue;
        const payload = item.payload && typeof item.payload === "object" ? item.payload : {};
        const stage = payload.stage || item.label || null;
        const ts = payload.ts || item.at || null;
        out.push({
            stage,
            status: payload.status ?? null,
            ts,
            turn_id: payload.turn_id ?? item.turnId ?? null,
            execution_id: payload.execution_id ?? null,
            conversation_id: payload.conversation_id ?? null,
            attrs:
                payload.attrs && typeof payload.attrs === "object" && !Array.isArray(payload.attrs)
                    ? payload.attrs
                    : {},
        });
    }
    return out;
}

export function filterEventsUntil(events = [], untilIso) {
    const list = Array.isArray(events) ? events : [];
    if (untilIso == null || untilIso === "") return list.slice();
    const untilMs = Date.parse(untilIso);
    if (!Number.isFinite(untilMs)) return list.slice();
    return list.filter((event) => {
        const ms = Date.parse(event?.ts);
        if (!Number.isFinite(ms)) return true;
        return ms <= untilMs;
    });
}

/** CW primeiro; timeline completa buracos. */
export function mergeTraceEvents(cwEvents = [], timelineEvents = []) {
    const map = new Map();
    for (const event of Array.isArray(timelineEvents) ? timelineEvents : []) {
        if (!event) continue;
        map.set(eventKey(event), event);
    }
    for (const event of Array.isArray(cwEvents) ? cwEvents : []) {
        if (!event) continue;
        const key = eventKey(event);
        const prev = map.get(key);
        if (!prev) {
            map.set(key, event);
            continue;
        }
        const prevAttrs = prev.attrs && typeof prev.attrs === "object" ? prev.attrs : {};
        const nextAttrs = event.attrs && typeof event.attrs === "object" ? event.attrs : {};
        map.set(key, {
            ...prev,
            ...event,
            attrs: { ...prevAttrs, ...nextAttrs },
        });
    }
    return Array.from(map.values()).sort((a, b) => {
        const da = Date.parse(a?.ts) || 0;
        const db = Date.parse(b?.ts) || 0;
        return da - db;
    });
}
